export default __webpack_public_path__ + "static/media/4.76d00881.jpg";